import { useEffect, useState } from 'react';
import {
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
    UncontrolledDropdown
} from 'reactstrap'

const languages = [
    { label: 'English', value: '/es/en', id: 'en' },
    { label: 'Español', value: '/es/es', id: 'es' },
    { label: 'Français', value: '/es/fr', id: 'fr' },
    { label: 'Deutsch', value: '/es/de', id: 'gr' },
    { label: 'Italiano', value: '/es/it', id: 'it' },
    { label: 'Português', value: '/es/pt', id: 'pt' },
    { label: 'Polski', value: '/es/pl', id: 'pl' },
    { label: 'Türkçe', value: '/es/tr', id: 'tr' },
    { label: 'Čeština', value: '/es/cs', id: 'cz' },
    { label: 'Slovenčina', value: '/es/sk', id: 'sk' },
    { label: 'Català', value: '/es/ca', id: 'cat' },
    { label: 'Nederlands', value: '/es/nl', id: 'nl' },
    { label: 'Norsk', value: '/es/no', id: 'nw' }
];

export default function GoogleTranslate() {
    const [selected, setSelected] = useState('/es/es');

    useEffect(() => {
        // Set dropdown to match active cookie
        const cookieMatch = document.cookie.match(/googtrans=([^;]+)/);
        setSelected(cookieMatch ? cookieMatch[1] : '/es/es');

        // Avoid injecting script or re-initializing if already done
        if (window._googleTranslateInitialized) return;
        window._googleTranslateInitialized = true;

        // Cleanup conflicting cookies BEFORE script loads
        document.cookie = `googtrans=; path=/; domain=${window.location.hostname}; expires=Thu, 01 Jan 1970 00:00:00 GMT`;
        document.cookie = `googtrans=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT`;

        // Init Google Translate callback
        window.googleTranslateElementInit = () => {
            new window.google.translate.TranslateElement(
                {
                    pageLanguage: 'es',
                    autoDisplay: false,
                    includedLanguages: languages.map(l => l.value.split('/')[2]).join(','),
                    layout: window.google.translate.TranslateElement.InlineLayout.SIMPLE
                },
                'google_translate_element'
            );
        };

        // Inject Google Translate script only once
        if (!document.querySelector('script[src*="translate.google.com"]')) {
            const script = document.createElement('script');
            script.src = '//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit';
            document.body.appendChild(script);
        }
    }, []);

    const handleLanguageClick = (langValue) => {
        const targetLang = langValue.split('/')[2];
        const sourceLang = 'es';
        const googtransValue = `/${sourceLang}/${targetLang}`;

        document.cookie = `googtrans=${googtransValue}; path=/; domain=.vacway.es`;
        document.cookie = `googtrans=${googtransValue}; path=/; domain=${window.location.hostname}`;
        document.cookie = `googtrans=${googtransValue}; path=/`;

        setSelected(googtransValue);
        
        // Delay reload slightly to let React finish cleanup
        setTimeout(() => {
            window.location.reload();
        }, 10);
    };

    const currentLang = languages.find(lang => lang.value === selected);

    return (
        <>
            <div id="google_translate_element" className="d-none" />
            <UncontrolledDropdown nav inNavbar>
                <DropdownToggle nav caret>
                    <img
                        src={`/languages/${currentLang?.id || 'es'}.png`}
                        alt={currentLang?.label || 'Español'}
                        style={{ width: 25, height: 25 }}
                        className="mr-2"
                    />
                </DropdownToggle>
                <DropdownMenu right>
                    {languages.map((lang) => (
                        <DropdownItem
                            key={lang.value}
                            onClick={() => handleLanguageClick(lang.value)}
                            className="d-flex align-items-center notranslate cursor-pointer"
                            translate="no"
                        >
                            <img
                                src={`/languages/${lang.id}.png`}
                                alt={lang.label}
                                className="mr-2"
                                style={{ width: 25, height: 25 }}
                            />
                            {lang.label}
                        </DropdownItem>
                    ))}
                </DropdownMenu>
            </UncontrolledDropdown>
        </>
    );
}
